import { eTuiThiActionsObj } from "../../action-types/tct/ITuiThiActions";
import { generateActions } from "../generateActions";

export const tuiThiActions = {
    ...generateActions(eTuiThiActionsObj, "TUI_THI"),
};
